import * as web3 from '@solana/web3.js';

export const FIRST_CREATOR_IS_LAST_INDEX = false ;//false; // change to false for mainnet as it's the first index 
                                                // instead of last


export const NETWORK = "mainnet-beta";

export const programId : web3.PublicKey = 

new web3.PublicKey("6yFB2DBieS3kCSFtm13rf4awtFbsqf6prGQw88eJuvqS");

// for $DAWG token 
export const DC_TOKEN_DECIMAL = 6; 

export const DC_TOKEN_MINT = "H3LwoFKijuDVAoJUroeySQKrhkqi7tUFGYKpEpU983nJ";

//"9QKHcZihXMdBgYdrWgqXCP6o6GWWb9ttsqS7WXSVuJZ8";

// This is the wallet address that created the $DAWG token vault
export const DC_TOKEN_VAULT_OWNER = "ExP5N4fGg8Fs49C77u6fMytQNtU6TA9ZtyRFC9Gnzntp";


// NFT token vault API URI
export const NFT_TOKEN_VAULT_API = "https://blockchainbillies-backend.vercel.app/api/tokenvault?mint=";

export const NFT_TOKEN_VAULT_FILE_WALLET = "DVAYe6rKgu9AuZYvvixvShosFeSZuD3cGrUFvF9h5S5Z";

export const STAKE_DATA_API = "https://blockchainbillies-backend.vercel.app/api/stakeData";


export const SIGN_IN_API = "https://blockchainbillies-backend.vercel.app/api/signin";


export const SIGN_OUT_API = "https://blockchainbillies-backend.vercel.app/api/signout";

// for DC NFT 
export const DC_UPDATE_AUTHORITY = "GgKEW6PEpj7wiuDcGaPQ4Wsib7xrr1a72NPTmLUwktvi";

export const DC_VALID_FIRST_CREATOR = "";
